export enum SpinnerType {
  normal,
  large
}
